

const setAuth = (value: boolean) => ({
    type: 'AUTH/SET_AUTH',
    value,
});

const setIds = (channelId: string, guildId: string) => ({
    type: 'AUTH/SET_IDS',
    channelId,
    guildId,
});


export {
    setAuth,
    setIds,
};
